import { render } from "./navigation-bars.vue?vue&type=template&id=38b41bb0&scoped=true"
import script from "./navigation-bars.vue?vue&type=script&setup=true&lang=js"
export * from "./navigation-bars.vue?vue&type=script&setup=true&lang=js"

import "./navigation-bars.vue?vue&type=style&index=0&id=38b41bb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b41bb0"],['__file',"src/layouts/main-layout/components/navigation-bars.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38b41bb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38b41bb0', __exports__)) {
    api.reload('38b41bb0', __exports__)
  }
  
  module.hot.accept("./navigation-bars.vue?vue&type=template&id=38b41bb0&scoped=true", () => {
    api.rerender('38b41bb0', render)
  })

}


export default __exports__